import { render, staticRenderFns } from "./GoodsOrders.vue?vue&type=template&id=51f35a77&"
import script from "./GoodsOrders.vue?vue&type=script&lang=js&"
export * from "./GoodsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports